module.exports = __webpack_public_path__ + "img/U1F6AB.906bf6b0.png";